<nz-page-header nzTitle="登录页设置">
  <nz-page-header-extra></nz-page-header-extra>
  <nz-page-header-footer>
    <div class="pb-[24px]" nz-row nzJustify="space-between" nzAlign="middle">
      <nz-tabs [nzSelectedIndex]="tabIndex" (nzSelectedIndexChange)="onTabChange($event)">
        <nz-tab nzTitle="默认模式"></nz-tab>
        <nz-tab nzTitle="小图模式"></nz-tab>
      </nz-tabs>
      <button
        [nz-tooltip]="
          siteTypeIndex !== tabIndex
            ? tabIndex === 0
              ? '启用默认模式后，将自动关闭小图模式'
              : '启用小图模式后，将自动关闭默认模式'
            : ''
        "
        nz-button
        flCheckLoginType
        (click)="changeModal()"
        >
        <span nz-icon [nzType]="siteTypeIndex === tabIndex ? 'edit' : 'play-circle'" nzTheme="outline"></span
          >{{ siteTypeIndex === tabIndex ? '编辑' : '启用' }}
        </button>
      </div>
    </nz-page-header-footer>
  </nz-page-header>

  <nz-content class="m-[16px]">
    <div class="bg-white p-[24px] rounded-[12px]">
      <div class="bg-white rounded-[12px] min-h-[900px] relative overflow-hidden" style="border: 1px solid #dfe5f0">
        <div
          class="pseudo-header flex items-center"
          [class.fixed-header]="tabIndex === 1"
          [class.big-header]="tabIndex === 0"
          >
          <div class="middle flex items-center">
            <img
              nz-image
              [nzSrc]="sharedSrv.site.logo"
              nzDisablePreview
              [nzFallback]="'assets/image/common/logo.png'"
              class="max-h-[30px]"
              />
            <span class="literal">智慧教学云</span>
          </div>
        </div>
        @if (tabIndex === 0) {
          <div class="home-container">
            <img
              nz-image
              [nzSrc]="bg"
              nzDisablePreview
              [nzFallback]="'assets/image/common/background.jpg'"
              class="home-img"
              />
            <ng-container *ngTemplateOutlet="bigLogin"></ng-container>
          </div>
        }

        @if (tabIndex === 1) {
          <div class="home-container" nz-row nzJustify="center" nzAlign="middle">
            <img
              nz-image
              [nzSrc]="'assets/image/common/big-bg.png'"
              nzDisablePreview
              [nzFallback]="'assets/image/common/big-bg.png'"
              class="home-img"
              />
            <ng-container *ngTemplateOutlet="smallLogin"></ng-container>
          </div>
        }
      </div>
    </div>
  </nz-content>

  <ng-template #bigLogin>
    <div class="login-card">
      <div class="no-demo-container" nz-row nzAlign="middle" nzJustify="center">
        <div class="w-[146px] h-[48px] bg-[#F7F9FE] mb-[36px]"></div>
        <div class="w-[291px] h-[48px] bg-[#F7F9FE] mb-[36px]"></div>
        <div class="w-[291px] h-[48px] bg-[#F7F9FE] mb-[36px]"></div>
        <div class="w-[291px] h-[48px] bg-[#1270FF]/[.1]"></div>
      </div>
    </div>
  </ng-template>

  <ng-template #smallLogin>
    <div nz-row class="bg-white absolute flex flex-nowrap h-[430px] bg-modal overflow-hidden">
      <img nz-image [nzSrc]="bg" nzDisablePreview class="w-[600px]" [nzFallback]="'assets/image/common/background.jpg'" />
      <div class="w-[464px] flex-shrink-0 flex flex-col items-center justify-center">
        <div class="w-[146px] h-[48px] bg-[#F7F9FE] mb-[36px]"></div>
        <div class="w-[291px] h-[48px] bg-[#F7F9FE] mb-[36px]"></div>
        <div class="w-[291px] h-[48px] bg-[#F7F9FE] mb-[36px]"></div>
        <div class="w-[291px] h-[48px] bg-[#1270FF]/[.1]"></div>
      </div>
    </div>
  </ng-template>

<nz-modal
  [(nzVisible)]="isVisible"
  nzTitle="编辑图片"
  [nzWidth]="'560px'"
  [nzFooter]="null"
  (nzOnCancel)="isVisible = false"
  (nzOnOk)="handleOk()"
>
  <ng-container *nzModalContent>
    <fl-image-crop
      (closeModal)="isVisible = false"
      [imageUrl]="cropImage"
      [ratio]="tabIndex === 0 ? 16 / 9 : 4 / 3"
      (imageCroppedChange)="cropped($event)"
      (changeOriginal)="changeImage()"
    ></fl-image-crop>
  </ng-container>
</nz-modal>
